import { render, staticRenderFns } from "./PageSections.vue?vue&type=template&id=171af9b6&scoped=true&"
import script from "./PageSections.vue?vue&type=script&lang=js&"
export * from "./PageSections.vue?vue&type=script&lang=js&"
import style0 from "./PageSections.vue?vue&type=style&index=0&id=171af9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171af9b6",
  null
  
)

export default component.exports